import * as React from 'react';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import PageHealthRisk from './pageHealthrisk';
import PageHistory from './pageHistory';
import PageRegulatoryDifficult from './pageRegulatoryDifficult';
import PageSensitiveGroup from './pageSensitiveGroup';


const PageLearnMore = () => {
  const [tabvalue, setTabValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };


  return (
    <>
      <div >
        <div>
          <TabContext value={tabvalue}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange}  >
                <Tab label="Health Risks" value="1"
                  sx={{
                    mr: 1,
                    borderRadius: 1,
                    px: 3,
                    py: 1,
                    textTransform: 'none',
                    bgcolor: '#cae6fd',
                    color: '#7C7C7C',
                    '&.Mui-selected': {
                      color: 'black',
                      bgcolor: '#c0e1fd'
                    },
                    '&:hover': {
                      bgcolor: tabvalue === '1' ? '#c0e1fd' : '#dbeefe',
                    },
                  }} />
                <Tab label="Timeline" value="2"
                  sx={{
                    mr: 1,
                    borderRadius: 1,
                    px: 3,
                    py: 1,
                    textTransform: 'none',
                    bgcolor: '#cae6fd',
                    color: '#7C7C7C',
                    '&.Mui-selected': {
                      color: 'black',
                      bgcolor: '#c0e1fd'
                    },
                    '&:hover': {
                      bgcolor: tabvalue === '2' ? '#c0e1fd' : '#dbeefe',
                    },
                  }} />
                <Tab label="Difficult to Regulate" value="3"
                  sx={{
                    mr: 1,
                    borderRadius: 1,
                    px: 3,
                    py: 1,
                    textTransform: 'none',
                    bgcolor: '#cae6fd',
                    color: '#7C7C7C',
                    '&.Mui-selected': {
                      color: 'black',
                      bgcolor: '#c0e1fd'
                    },
                    '&:hover': {
                      bgcolor: tabvalue === '3' ? '#c0e1fd' : '#dbeefe',
                    },
                  }} />
                <Tab label="Who Are At Risk" value="4"
                  sx={{
                    mr: 1,
                    borderRadius: 1,
                    px: 3,
                    py: 1,
                    textTransform: 'none',
                    bgcolor: '#cae6fd',
                    color: '#7C7C7C',
                    '&.Mui-selected': {
                      color: 'black',
                      bgcolor: '#c0e1fd'
                    },
                    '&:hover': {
                      bgcolor: tabvalue === '4' ? '#c0e1fd' : '#dbeefe',
                    },
                  }} />
              </TabList>
            </Box>
            <TabPanel value="1"><PageHealthRisk /></TabPanel>
            <TabPanel value="2"><PageHistory /></TabPanel>
            <TabPanel value="3"><PageRegulatoryDifficult /></TabPanel>
            <TabPanel value="4"><PageSensitiveGroup /></TabPanel>
          </TabContext>
        </div>
      </div>
    </>
  );
}

export default PageLearnMore;